import { Icon } from "../icon";
import type { IconName } from "../icon/IconName";
import "./sidebar.css";

type SidebarTabType = {
    id: string; 
    label: string; 
    icon: IconName;
    path: string; 
};

interface AdminSidebarProps {
  activeTab: string;
  tabs: SidebarTabType[];
  onChange: (tab: SidebarTabType) => void;
};


export default function AdminSidebar({
  activeTab,
  tabs,
  onChange,
}: AdminSidebarProps) {
  return (
    <aside className="sidebar">
      <h2 className="sidebar-title">
        Administration
      </h2>

      <nav className="sidebar-nav">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`sidebar-item ${
              activeTab === tab.id ? "active" : ""
            }`}
            onClick={() => 
              onChange(tab)}
          >
            <Icon className="sidebar-icon" name={tab.icon}>
            </Icon>

            {tab.label}
          </button>
        ))}
      </nav>
    </aside>
  );
}